import { getSdk } from 'gql'
import { GraphQLClient } from 'graphql-request'

const endpoint = process.env.REACT_APP_GRAPHQL_PUBLIC_ENDPOINT ?? ''
const client = new GraphQLClient(endpoint)
export const graphqlSdk = getSdk(client)
